import type { DBCharacter } from '../../services/CharacterService';
import { freshCharacterEntryUrl } from './freshCharacterEntry';
import { navigateInGame } from '../../../config/boot/inGameNavigation';

/** Public roster selection resumes the API-owned map, not the mode's hub.
 * Existing transfer/keep-character and developer entry intents remain owned
 * by their current flows. Missing legacy location data keeps its old fallback.
 */
export function resumeCharacterEntryUrl(
  character: Pick<DBCharacter, 'levelId' | 'userId'>,
  current: URL,
  mainGameDomain: boolean,
): string | null {
  if (!mainGameDomain || current.pathname !== '/resume') return null;
  if (!character.userId?.startsWith('twitch:')) return null;
  const params = current.searchParams;
  if (params.get('keepCharacter') === '1'
    || ['transfer', 'spawn', 'class', 'createCharacter', 'peaceful', 'biomeTour', 'editor']
      .some(flag => params.has(flag))) return null;
  if (params.has('preset') && params.get('preset') !== 'live-lobby') return null;
  return freshCharacterEntryUrl(character.levelId, current);
}

export function navigateResumeCharacter(url: string): void {
  navigateInGame(url);
}
